function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function extractAddressText(value: unknown): string {
  if (typeof value === 'string') {
    return value;
  }

  if (isRecord(value)) {
    const street = value.street;
    const address = value.address;

    if (typeof street === 'string' && street.trim()) return street;
    if (typeof address === 'string' && address.trim()) return address;
  }

  return '';
}
